import { useLayoutEffect, useRef, useState } from 'react';

/** Gives an Ant table one bounded vertical scroller beneath its header. */
export const useTableScrollY = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [y, setY] = useState<number | undefined>(undefined);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return undefined;

    const recompute = () => {
      const header = element.querySelector<HTMLElement>('.ant-table-thead');
      const next = element.clientHeight - (header?.offsetHeight ?? 39);
      setY(next > 0 ? next : undefined);
    };

    const observer = new ResizeObserver(recompute);
    observer.observe(element);
    recompute();

    return () => observer.disconnect();
  }, []);

  return { ref, y };
};
